export const translations = {
  sv: {
    // Navigation
    automation: 'Automation',
    marketing: 'Marknadsföring',
    about: 'Om oss',
    contact: 'Kontakt',
    bookMeeting: 'Boka möte',
    
    // Home page
    eyebrow: 'Automation · Integration · Webbutveckling · Skräddarsydda lösningar · Ai',
    heroTitle: 'Vi förenklar det komplexa så att ni kan fokusera på tillväxt.',
    heroText: 'Velyntor minskar manuellt arbete med upp till 80 % genom att ta hand om hela kedjan – från att koppla ihop era system, bygga och vidareutveckla er webb och automatisera återkommande arbetsflöden till att sätta upp bevakning, rapporter och förbättringar över tid, så att ni får en helhetslösning som bara fungerar.',
    
    // Services
    processAutomation: 'Processautomation',
    processAutomationDesc: 'Kartlägger manuella flöden och bygger smarta automatiseringar som minskar ledtid, fel och frigör tid för värdeskapande arbete.',
    integrations: 'Integrationer',
    integrationsDesc: 'Kopplar ihop era system via säkra API:er, eventdrivna flöden och robust datakvalitet.',
    aiAssistants: 'AI-drivna assistenter',
    aiAssistantsDesc: 'Designar assistenter som svarar på kundfrågor, initierar ärenden och triggar interna processer.',
    marketingService: 'Marknadsföring',
    marketingServiceDesc: 'Automatiserar kampanjflöden och lead-hantering med spårbarhet, segmentering och smarta triggers.',
    measurableOps: 'Mätbar drift',
    measurableOpsDesc: 'Kontinuerlig övervakning, larm och rapporter som visar värdet av varje automation.',
    
    // Steps
    step1Title: '1. Snabb nulägesbild',
    step1Detail: 'Vi bokar ett kostnadsfritt mötepå 60 minuter där vi identifierar de mest lönsamma automationslösningarna.',
    step2Title: '2. Prototyp → produktion',
    step2Detail: 'Vi bygger en POC på 2-3 veckor och tar den vidare till produktion utan att tappa tempo.',
    step3Title: '3. Driftsättning & mätning',
    step3Detail: 'Säkra pipelines, loggning och KPI:er som följer upp varje körning och effekt.',
    step4Title: '4. Förvaltning',
    step4Detail: 'Löpande förbättringar, nya triggers och support så att värdet fortsätter öka.',
    
    // Platform
    eventDriven: 'Händelsedriven arkitektur',
    eventDrivenDesc: 'System som reagerar på händelser i realtid',
    apiFirst: 'API-first',
    apiFirstDesc: 'Bygger lösningar med API:er i fokus',
    cicd: 'CI/CD & IaC',
    cicdDesc: 'Automatiserad utveckling och driftsättning',
    observability: 'Observability',
    observabilityDesc: 'Fullständig insyn i systemets prestanda',
    llmAgents: 'LLM-agenter',
    llmAgentsDesc: 'AI-assistenter som förstår och agerar',
    security: 'Säkerhetsgranskning',
    securityDesc: 'Kontinuerlig säkerhetsanalys och förbättringar',
    
    // CTA
    ctaTitle: 'Redo att automatisera?',
    ctaSubtitle: 'Beskriv kort ert nuläge så återkommer vi med ett konkret förslag inom 24 timmar.',
    ctaTitle2: 'Vill ni minska manuellt arbete och få mer gjort automatiskt?',
    email: 'info@velyntor.se',
    
    // Services section
    servicesEyebrow: 'Tjänster',
    servicesTitle: 'Automation levererat end-to-end.',
    servicesSubtitle: 'Från processkartläggning och design till drift och mätning. Vi levererar hela kedjan.',
    
    // Platform section
    platformEyebrow: 'Plattform',
    platformTitle: 'Teknik som håller över tid.',
    platformSubtitle: 'Vi kombinerar moderna integrationer, molnplattformar och AI-modeller för robusta flöden.',
    
    // Process section
    processEyebrow: 'Arbetssätt',
    processTitle: 'Så levererar vi resultat snabbt.',
    
    // Hero card
    automationStatus: 'Automationsstatus',
    reductionLabel: 'reduktion av manuella moment',
    revenueLabel: 'ökad omsättning hos våra kunder',
    availabilityLabel: 'tillgänglighet i produktion',
    cardFooter: 'Data från senaste 12 månaderna hos våra kunder.',
    
    // Footer
    footerContact: 'Kontakt',
    footerPages: 'Sidor',
    footerRights: 'Alla rättigheter förbehållna.',
    
    // Contact page
    contactTitle: 'Kontakt',
    contactSubtitle: 'Låt oss diskutera ditt projekt',
    contactDescription: 'Fyll i formuläret nedan så återkommer vi med ett konkret förslag inom 24 timmar.',
    formName: 'Namn',
    formEmail: 'E-post',
    formSubject: 'Ämne',
    formMessage: 'Meddelande',
    formSend: 'Skicka',
    formSendMessage: 'Skicka meddelande',
    formNamePlaceholder: 'Ditt namn',
    formEmailPlaceholder: 'din.epost@exempel.se',
    formMessagePlaceholder: 'Beskriv kort ert nuläge och vad ni behöver hjälp med...',
    formSelectSubject: 'Välj ämne',
    formSuccess: 'Tack! Vi har mottagit ditt meddelande och återkommer inom 24 timmar.',
    subjectAutomation: 'Automation',
    subjectMarketing: 'Marknadsföring',
    subjectWebDevelopment: 'Webbutveckling',
    subjectOther: 'Annat',
    
    // About page
    aboutEyebrow: 'Velyntor',
    aboutText1: 'Velyntor grundades 2024 och har sedan dess haft enorm tillväxt. Vi har hjälpt flertals företag att öka sin omsättning genom smarta automatiseringar och digitala lösningar.',
    aboutText2: 'Sedan vår start har vi vuxit snabbt och etablerat oss som en pålitlig partner för företag som vill automatisera sina processer och öka sin omsättning. Vi har hjälpt flertals företag att nå sina mål genom att förenkla komplexa processer, automatisera repetitiva moment och skapa digitala lösningar som genererar verkligt värde.',
    aboutText3: 'Våra kunder har sett konkreta resultat. Genom våra automatiseringar och digitala lösningar har vi hjälpt företag att öka sin omsättning betydligt. Vi fokuserar på lösningar som ger omedelbar påverkan och långsiktigt värde, så att våra kunder kan fortsätta växa och utvecklas.',
    aboutText4: 'Vi kombinerar modern teknik och beprövade metoder för att skapa lösningar som fungerar i praktiken. Varje projekt är unikt, men vårt fokus är alltid detsamma: att skapa värde genom processautomation, systemintegration, AI-drivna lösningar och digital marknadsföring.',
    
    // Marketing page
    marketingEyebrow: 'Marknadsföring',
    marketingTitle: 'Fler kunder. Mindre arbete.',
    marketingText1: 'En digital närvaro som arbetar för dig.',
    marketingText2: 'Med våra lösningar får du en digital tillväxtmotor som genererar verkliga resultat — strategi, trafik, webbplats och kontinuerliga uppdateringar i ett samlat system.',
    marketingText3: 'Vi hanterar allt tekniskt och taktiskt, så att du kan koncentrera dig på din verksamhet.',
    marketingText4: 'Du behöver inte lägga tid på det digitala. Du får fler kunder, månad efter månad.',
    marketingPartnership: 'Samarbete',
    marketingPartnershipTitle: 'Beprövad erfarenhet',
    marketingPartnershipText1: 'Vi bygger lösningar baserade på gedigen erfarenhet, djup kompetens och ett arbetssätt som har visat sig fungera i praktiken. Genom strategiska samarbeten och ett starkt nätverk av specialister kan vi leverera moderna, effektiva och skalbara tjänster som gör verklig skillnad.',
    marketingPartnershipText2: 'Vår styrka ligger i kombinationen av teknisk spets, affärsförståelse och långsiktigt tänkande. Vi skapar lösningar som inte bara ser bra ut, de är byggda för att prestera, konvertera och växa tillsammans med er verksamhet.',
    marketingPartnershipText3: 'Vi vet vad som krävs för att lyckas i dagens digitala landskap. Därför fokuserar vi på genomtänkta strategier, smarta lösningar och ett utförande där varje detalj har ett syfte. Resultatet blir system och tjänster som är stabila, flexibla och anpassade för framtiden.',
    marketingPartnershipText4: 'Bakom varje leverans finns ett strukturerat arbetssätt, beprövade metoder och en tydlig ambition: att skapa lösningar som ger mätbara resultat och ett tydligt konkurrensförsprång.',
    marketingPartnershipText5: 'När ni samarbetar med oss får ni inte standardlösningar, ni får genomarbetade, professionella och kraftfulla tjänster som är byggda för att ta er verksamhet till nästa nivå.',
    marketingAds: 'Annonsering',
    marketingAdsTitle: 'Gör din synlighet lönsam',
    marketingAdsText1: 'Idag börjar nästan alla kundresor online. När dina kunder söker efter en lösning vill vi att det är dig de hittar – och väljer.',
    marketingAdsText2: 'Med våra annonser bygger vi en närvaro som driver faktiska förfrågningar, inte bara trafik.',
    marketingAdsButton: 'Prova i 3 månader – helt riskfritt',
    marketingAdsDisclaimer: 'Ingen bindningstid. Inga dolda villkor.',
    marketingPhilosophy: 'Vår filosofi',
    marketingPhilosophyTitle: 'Precision som ger resultat',
    marketingPhilosophyText1: 'Vi tror inte på att göra mer för sakens skull – vi tror på att göra rätt saker. För oss handlar digital tillväxt om träffsäkerhet, inte volym. Varje strategi, varje kampanj och varje webbplats vi tar fram har ett tydligt syfte: att skapa fler kunder på ett smartare, mer effektivt sätt.',
    marketingPhilosophyText2: 'Vi bygger inte digital närvaro för att du ska synas överallt – vi ser till att du syns där besluten faktiskt tas. När du är relevant på rätt plats, vid rätt tillfälle, blir precision den kraft som driver er tillväxt – om och om igen.',
    marketingCtaTitle: 'Redo att växa digitalt?',
    marketingCtaSubtitle: 'Beskriv kort ert nuläge så återkommer vi med ett konkret förslag inom 24 timmar.',
    
    // Web Development page
    webDevelopment: 'Webbutveckling',
    webDevEyebrow: 'Webbutveckling',
    webDevTitle: 'Modern webb som växer med er.',
    webDevText1: 'En webbplats som fungerar som den ska.',
    webDevText2: 'Vi bygger moderna, snabba och användarvänliga webbplatser som konverterar besökare till kunder. Från design och utveckling till drift och underhåll – vi tar hand om hela kedjan.',
    webDevText3: 'Med fokus på prestanda, säkerhet och användarupplevelse skapar vi webbplatser som inte bara ser bra ut, utan också levererar resultat.',
    webDevText4: 'Ni får en webbplats som är byggd för att växa tillsammans med er verksamhet.',
    webDevServices: 'Tjänster',
    webDevServicesTitle: 'Hela webbutvecklingsprocessen',
    webDevServicesText1: 'Vi erbjuder kompletta webbutvecklingslösningar från idé till lansering och vidareutveckling. Våra tjänster inkluderar design, utveckling, optimering och kontinuerligt underhåll.',
    webDevServicesText2: 'Oavsett om ni behöver en ny webbplats, en uppdatering av er befintliga eller en komplett digital transformation – vi har kompetensen och erfarenheten att leverera.',
    webDevTech: 'Teknik',
    webDevTechTitle: 'Moderna teknologier',
    webDevTechText1: 'Vi arbetar med de senaste teknologierna och bästa praxis för att säkerställa att er webbplats är snabb, säker och framtidssäker.',
    webDevTechText2: 'Från React och modern JavaScript till molnbaserade lösningar och API-integrationer – vi väljer rätt teknik för varje projekt.',
    webDevApproach: 'Vårt arbetssätt',
    webDevApproachTitle: 'Från idé till lansering',
    webDevApproachText1: 'Vi börjar med att förstå er verksamhet, era mål och era användare. Sedan designar och utvecklar vi en lösning som är anpassad efter era specifika behov.',
    webDevApproachText2: 'Genom kontinuerlig kommunikation och iterativ utveckling säkerställer vi att resultatet överstiger era förväntningar.',
    webDevCtaTitle: 'Redo att bygga er webb?',
    webDevCtaSubtitle: 'Beskriv kort ert projekt så återkommer vi med ett konkret förslag inom 24 timmar.',
    webDevServiceDesign: 'Design & UX',
    webDevServiceDesignDesc: 'Användarcentrerad design som skapar engagerande upplevelser och höjer konverteringar.',
    webDevServiceDevelopment: 'Frontend & Backend',
    webDevServiceDevelopmentDesc: 'Modern utveckling med React, Node.js och molnbaserade lösningar för snabba och skalbara webbplatser.',
    webDevServiceEcommerce: 'E-handel',
    webDevServiceEcommerceDesc: 'Kompletta e-handelslösningar med betalningar, lagerhantering och orderflöden.',
    webDevServiceMaintenance: 'Underhåll & Support',
    webDevServiceMaintenanceDesc: 'Kontinuerlig uppdatering, säkerhetsövervakning och teknisk support för att hålla er webbplats optimal.',
    webDevServiceIntegration: 'Systemintegration',
    webDevServiceIntegrationDesc: 'Kopplar ihop er webbplats med era befintliga system och verktyg för smidiga arbetsflöden.',
    webDevTechStack: 'Teknologier vi arbetar med',
    webDevTechReact: 'React',
    webDevTechReactDesc: 'Bygger snabba, responsiva gränssnitt som känns moderna på alla enheter.',
    webDevTechNode: 'Node.js',
    webDevTechNodeDesc: 'Stabil backend som klarar integrationer, API:er och komplex logik.',
    webDevTechCloud: 'Molnlösningar',
    webDevTechCloudDesc: 'Drift i molnet för bättre skalbarhet, tillgänglighet och säkerhet.',
    webDevTechAPI: 'API-integrationer',
    webDevTechAPIDesc: 'Kopplar ihop system så att data rör sig automatiskt mellan era verktyg.',
    webDevTechSecurity: 'Säkerhet',
    webDevTechSecurityDesc: 'Fokuserar på säkra implementationer, uppdateringar och best practices.',
    webDevTechPerformance: 'Prestanda',
    webDevTechPerformanceDesc: 'Optimerar laddtider och upplevelse så att sidan känns snabb även under belastning.',
    webDevProcess1: '1. Analys & Planering',
    webDevProcess1Desc: 'Vi analyserar era behov, mål och målgrupp för att skapa en tydlig plan.',
    webDevProcess2: '2. Design & Prototyp',
    webDevProcess2Desc: 'Vi designar en prototyp som ni kan testa och godkänna innan utveckling börjar.',
    webDevProcess3: '3. Utveckling',
    webDevProcess3Desc: 'Agil utveckling med regelbundna leveranser så ni ser framstegen kontinuerligt.',
    webDevProcess4: '4. Test & Lansering',
    webDevProcess4Desc: 'Omfattande testning och optimering innan vi lanserar er nya webbplats.',
    webDevProcess5: '5. Underhåll',
    webDevProcess5Desc: 'Kontinuerligt underhåll och förbättringar för att säkerställa optimal prestanda.',
  },
  en: {
    // Navigation
    automation: 'Automation',
    marketing: 'Marketing',
    about: 'About',
    contact: 'Contact',
    bookMeeting: 'Book meeting',
    
    // Home page
    eyebrow: 'Automation · Integration · Web Development · Custom Solutions · AI',
    heroTitle: 'We simplify the complex so you can focus on growth.',
    heroText: 'Velyntor reduces manual work by up to 80% by handling the entire chain – from connecting your systems, building and developing your web presence, and automating recurring workflows to setting up monitoring, reports, and improvements over time, so you get a complete solution that just works.',
    
    // Services
    processAutomation: 'Process Automation',
    processAutomationDesc: 'Maps manual flows and builds smart automations that reduce lead time, errors, and free up time for value-creating work.',
    integrations: 'Integrations',
    integrationsDesc: 'Connects your systems via secure APIs, event-driven flows, and robust data quality.',
    aiAssistants: 'AI-driven Assistants',
    aiAssistantsDesc: 'Designs assistants that answer customer questions, initiate cases, and trigger internal processes.',
    marketingService: 'Marketing',
    marketingServiceDesc: 'Automates campaign flows and lead management with tracking, segmentation, and smart triggers.',
    measurableOps: 'Measurable Operations',
    measurableOpsDesc: 'Continuous monitoring, alerts, and reports that show the value of each automation.',
    
    // Steps
    step1Title: '1. Quick Assessment',
    step1Detail: 'We book a free 60-minute meeting where we identify the most profitable automation solutions.',
    step2Title: '2. Prototype → Production',
    step2Detail: 'We build a POC in 2-3 weeks and take it to production without losing momentum.',
    step3Title: '3. Deployment & Measurement',
    step3Detail: 'Secure pipelines, logging, and KPIs that track every run and effect.',
    step4Title: '4. Maintenance',
    step4Detail: 'Ongoing improvements, new triggers, and support so the value continues to increase.',
    
    // Platform
    eventDriven: 'Event-driven Architecture',
    eventDrivenDesc: 'Systems that react to events in real-time',
    apiFirst: 'API-first',
    apiFirstDesc: 'Building solutions with APIs in focus',
    cicd: 'CI/CD & IaC',
    cicdDesc: 'Automated development and deployment',
    observability: 'Observability',
    observabilityDesc: 'Complete insight into system performance',
    llmAgents: 'LLM Agents',
    llmAgentsDesc: 'AI assistants that understand and act',
    security: 'Security Review',
    securityDesc: 'Continuous security analysis and improvements',
    
    // CTA
    ctaTitle: 'Ready to automate?',
    ctaSubtitle: 'Briefly describe your current situation and we will return with a concrete proposal within 24 hours.',
    ctaTitle2: 'Want to reduce manual work and get more done automatically?',
    email: 'info@velyntor.se',
    
    // Services section
    servicesEyebrow: 'Services',
    servicesTitle: 'Automation delivered end-to-end.',
    servicesSubtitle: 'From process mapping and design to operations and measurement. We deliver the entire chain.',
    
    // Platform section
    platformEyebrow: 'Platform',
    platformTitle: 'Technology that lasts over time.',
    platformSubtitle: 'We combine modern integrations, cloud platforms, and AI models for robust flows.',
    
    // Process section
    processEyebrow: 'Working Method',
    processTitle: 'How we deliver results quickly.',
    
    // Hero card
    automationStatus: 'Automation Status',
    reductionLabel: 'reduction in manual tasks',
    revenueLabel: 'increased revenue for our customers',
    availabilityLabel: 'availability in production',
    cardFooter: 'Data from the last 12 months from our customers.',
    
    // Footer
    footerContact: 'Contact',
    footerPages: 'Pages',
    footerRights: 'All rights reserved.',
    
    // Contact page
    contactTitle: 'Contact',
    contactSubtitle: 'Let\'s discuss your project',
    contactDescription: 'Fill in the form below and we will return with a concrete proposal within 24 hours.',
    formName: 'Name',
    formEmail: 'Email',
    formSubject: 'Subject',
    formMessage: 'Message',
    formSend: 'Send',
    formSendMessage: 'Send message',
    formNamePlaceholder: 'Your name',
    formEmailPlaceholder: 'your.email@example.com',
    formMessagePlaceholder: 'Briefly describe your current situation and what you need help with...',
    formSelectSubject: 'Select subject',
    formSuccess: 'Thank you! We have received your message and will get back to you within 24 hours.',
    subjectAutomation: 'Automation',
    subjectMarketing: 'Marketing',
    subjectWebDevelopment: 'Web Development',
    subjectOther: 'Other',
    
    // About page
    aboutEyebrow: 'Velyntor',
    aboutText1: 'Velyntor was founded in 2024 and has since experienced tremendous growth. We have helped numerous companies increase their revenue through smart automations and digital solutions.',
    aboutText2: 'Since our start, we have grown rapidly and established ourselves as a reliable partner for companies that want to automate their processes and increase their revenue. We have helped numerous companies achieve their goals by simplifying complex processes, automating repetitive tasks, and creating digital solutions that generate real value.',
    aboutText3: 'Our customers have seen concrete results. Through our automations and digital solutions, we have helped companies significantly increase their revenue. We focus on solutions that provide immediate impact and long-term value, so our customers can continue to grow and develop.',
    aboutText4: 'We combine modern technology and proven methods to create solutions that work in practice. Every project is unique, but our focus is always the same: creating value through process automation, system integration, AI-driven solutions, and digital marketing.',
    
    // Marketing page
    marketingEyebrow: 'Marketing',
    marketingTitle: 'More customers. Less work.',
    marketingText1: 'A digital presence that works for you.',
    marketingText2: 'With our solutions, you get a digital growth engine that generates real results — strategy, traffic, website, and continuous updates in one integrated system.',
    marketingText3: 'We handle everything technical and tactical, so you can focus on your business.',
    marketingText4: 'You don\'t need to spend time on the digital. You get more customers, month after month.',
    marketingPartnership: 'Partnership',
    marketingPartnershipTitle: 'Proven Experience',
    marketingPartnershipText1: 'We build solutions based on solid experience, deep expertise, and a working method that has proven to work in practice. Through strategic partnerships and a strong network of specialists, we can deliver modern, efficient, and scalable services that make a real difference.',
    marketingPartnershipText2: 'Our strength lies in the combination of technical excellence, business understanding, and long-term thinking. We create solutions that not only look good, they are built to perform, convert, and grow together with your business.',
    marketingPartnershipText3: 'We know what it takes to succeed in today\'s digital landscape. That\'s why we focus on thoughtful strategies, smart solutions, and execution where every detail has a purpose. The result is systems and services that are stable, flexible, and adapted for the future.',
    marketingPartnershipText4: 'Behind every delivery is a structured working method, proven methods, and a clear ambition: to create solutions that deliver measurable results and a clear competitive advantage.',
    marketingPartnershipText5: 'When you work with us, you don\'t get standard solutions, you get well-crafted, professional, and powerful services that are built to take your business to the next level.',
    marketingAds: 'Advertising',
    marketingAdsTitle: 'Make your visibility profitable',
    marketingAdsText1: 'Today, almost every customer journey starts online. When your customers look for a solution, we want it to be you they find – and choose.',
    marketingAdsText2: 'With our advertising, we build a presence that drives real enquiries, not just clicks.',
    marketingAdsButton: 'Try it for 3 months – completely risk-free',
    marketingAdsDisclaimer: 'No commitment period. No hidden terms.',
    marketingPhilosophy: 'Our Philosophy',
    marketingPhilosophyTitle: 'Precision that delivers',
    marketingPhilosophyText1: 'We don\'t believe in doing more for its own sake – we believe in doing the right things. For us, digital growth is about accuracy, not volume. Every strategy, every campaign, and every website we create has a clear purpose: to generate more customers in a smarter, more effective way.',
    marketingPhilosophyText2: 'We don\'t build digital presence so you\'re seen everywhere – we make sure you\'re seen where decisions are actually made. When you are relevant in the right place at the right time, precision becomes the force that drives your growth – again and again.',
    marketingCtaTitle: 'Ready to grow digitally?',
    marketingCtaSubtitle: 'Briefly describe your current situation and we will return with a concrete proposal within 24 hours.',
    
    // Web Development page
    webDevelopment: 'Web Development',
    webDevEyebrow: 'Web Development',
    webDevTitle: 'Modern web that grows with you.',
    webDevText1: 'A website that works as it should.',
    webDevText2: 'We build modern, fast, and user-friendly websites that convert visitors into customers. From design and development to operations and maintenance – we handle the entire chain.',
    webDevText3: 'With a focus on performance, security, and user experience, we create websites that not only look good but also deliver results.',
    webDevText4: 'You get a website that is built to grow together with your business.',
    webDevServices: 'Services',
    webDevServicesTitle: 'The entire web development process',
    webDevServicesText1: 'We offer complete web development solutions from idea to launch and further development. Our services include design, development, optimization, and continuous maintenance.',
    webDevServicesText2: 'Whether you need a new website, an update to your existing one, or a complete digital transformation – we have the expertise and experience to deliver.',
    webDevTech: 'Technology',
    webDevTechTitle: 'Modern technologies',
    webDevTechText1: 'We work with the latest technologies and best practices to ensure your website is fast, secure, and future-proof.',
    webDevTechText2: 'From React and modern JavaScript to cloud-based solutions and API integrations – we choose the right technology for each project.',
    webDevApproach: 'Our Approach',
    webDevApproachTitle: 'From idea to launch',
    webDevApproachText1: 'We start by understanding your business, your goals, and your users. Then we design and develop a solution tailored to your specific needs.',
    webDevApproachText2: 'Through continuous communication and iterative development, we ensure the result exceeds your expectations.',
    webDevCtaTitle: 'Ready to build your web?',
    webDevCtaSubtitle: 'Briefly describe your project and we will return with a concrete proposal within 24 hours.',
    webDevServiceDesign: 'Design & UX',
    webDevServiceDesignDesc: 'User-centered design that creates engaging experiences and increases conversions.',
    webDevServiceDevelopment: 'Frontend & Backend',
    webDevServiceDevelopmentDesc: 'Modern development with React, Node.js and cloud-based solutions for fast and scalable websites.',
    webDevServiceEcommerce: 'E-commerce',
    webDevServiceEcommerceDesc: 'Complete e-commerce solutions with payments, inventory management and order flows.',
    webDevServiceMaintenance: 'Maintenance & Support',
    webDevServiceMaintenanceDesc: 'Continuous updates, security monitoring and technical support to keep your website optimal.',
    webDevServiceIntegration: 'System Integration',
    webDevServiceIntegrationDesc: 'Connects your website with your existing systems and tools for smooth workflows.',
    webDevTechStack: 'Technologies we work with',
    webDevTechReact: 'React',
    webDevTechReactDesc: 'Builds fast, responsive interfaces that feel modern on every device.',
    webDevTechNode: 'Node.js',
    webDevTechNodeDesc: 'Reliable backend handling integrations, APIs, and complex logic.',
    webDevTechCloud: 'Cloud Solutions',
    webDevTechCloudDesc: 'Cloud hosting for better scalability, availability, and security.',
    webDevTechAPI: 'API Integrations',
    webDevTechAPIDesc: 'Connects systems so data flows automatically between your tools.',
    webDevTechSecurity: 'Security',
    webDevTechSecurityDesc: 'Focus on secure implementations, updates, and best practices.',
    webDevTechPerformance: 'Performance',
    webDevTechPerformanceDesc: 'Optimizes load times and experience so the site feels fast even under load.',
    webDevProcess1: '1. Analysis & Planning',
    webDevProcess1Desc: 'We analyze your needs, goals and target audience to create a clear plan.',
    webDevProcess2: '2. Design & Prototype',
    webDevProcess2Desc: 'We design a prototype that you can test and approve before development begins.',
    webDevProcess3: '3. Development',
    webDevProcess3Desc: 'Agile development with regular deliveries so you see progress continuously.',
    webDevProcess4: '4. Test & Launch',
    webDevProcess4Desc: 'Comprehensive testing and optimization before we launch your new website.',
    webDevProcess5: '5. Maintenance',
    webDevProcess5Desc: 'Continuous maintenance and improvements to ensure optimal performance.',
  }
};

